<template>
  <div class="gestion-dispensacion">
    <h1>Gestión de Dispensación Medicinal</h1>
    <div class="button-group">
      <button class="btn btn-primary" @click="currentView = 'listar'"><font-awesome-icon :icon="['fas', 'list']" /> Listar Dispensaciones</button>
      <button class="btn btn-secondary" @click="currentView = 'crear'"><font-awesome-icon :icon="['fas', 'plus']" /> Crear Dispensación</button>
    </div>
    <div v-if="currentView === 'crear'">
      <DispensacionForm :usuario="usuario" @cancelar="currentView = 'listar'" @actualizar="actualizarDispensacion" @guardar="guardarDispensacion" />
    </div>
    <div v-if="currentView === 'listar'">
      <ListarDispensacion :usuario="usuario" @editarDispensacion="editarDispensacion" />
    </div>
    <div v-if="currentView === 'editar'">
      <DispensacionForm :dispensacion="selectedDispensacion" :usuario="usuario" @cancelar="currentView = 'listar'" @actualizar="actualizarDispensacion" @guardar="guardarDispensacion" />
    </div>
  </div>
</template>

<script>

import ListarDispensacion from './ListarDispensacion.vue';
import DispensacionForm from './DispensacionForm.vue';
export default {

  components: {
    DispensacionForm,
    ListarDispensacion,
  },
  props: {
    usuario: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentView: 'listar',
      selectedDispensacion: null // Esto se actualizará cuando se seleccione una dispensación para editar
    };
  },
  methods: {
    seleccionarDispensacion(dispensacion) {
      this.selectedDispensacion = dispensacion;
      this.currentView = 'editar';
    },
    actualizarDispensacion() {
      this.currentView = 'listar';
    },
    guardarDispensacion() {
      this.currentView = 'listar';
    },
    editarDispensacion(dispensacion) {
      this.selectedDispensacion = dispensacion;
      this.currentView = 'editar';
    }
  }
};
</script>

<style scoped>
.gestion-dispensacion {
  padding: 2rem;
  background-color: #f9fbf9; /* Usar el color definido en custom-bootstrap.scss */
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.button-group {
  margin-bottom: 1.5rem;
}

button {
  margin-right: 1rem;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #3e6b32; /* Usar un color más oscuro del verde oliva */
}
</style> 